var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_facebook",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1069672,19.2 L10.1951241,12 L8.60439918,11.911063 L8.69177592,9.48869867 L10.1054069,9.57607541 L10.1951241,7.97676888 C10.1951241,6.92902806 10.4439918,6.13015495 10.9331455,5.59731282 C11.420739,5.06837144 12.239896,4.8 13.3711128,4.8 L15.3792177,4.8 L15.2910608,7.22236429 L14.1239571,7.13498754 C13.8860115,7.13498754 13.6925344,7.15605158 13.5466464,7.19505905 C13.3859356,7.24030773 13.2673529,7.32300358 13.1940189,7.4415863 C13.1261458,7.55080724 13.0816773,7.66392892 13.0621736,7.7786109 C13.04345,7.88627154 13.0348683,8.03684039 13.0348683,8.23187778 L13.0348683,9.48791852 L15.3956008,9.57607541 L15.0421931,11.9898581 L13.1238054,11.911063 L13.0356485,19.2 L10.1069672,19.2 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.bdb91df5.svg";
export { ForwardRef as ReactComponent };